import { createSlice } from '@reduxjs/toolkit';

interface ActiveListState {
  activeList: 'Purchased' | 'Pending';
  userManagementType: 'Agents' | 'Distributors' | 'Sub Distributors' | 'Master Distributors' | 'Retailers' | 'Customers';
  userCode?: string;
  userName?: string;
}

const initialState: ActiveListState = {
  activeList: 'Purchased',
  userManagementType: 'Master Distributors',
  userCode: '',
  userName: ''
};

const activeListSlice = createSlice({
  name: 'activeList',
  initialState,
  reducers: {
    setActiveList: (state, action) => {
      state.activeList = action.payload;
    },
    setUserManagementType: (state, action) => {
      state.userManagementType = action.payload;
    },
    setUserCode: (state, action) => {
      state.userCode = action.payload;
    },
    setUserName: (state, action) => {
      state.userName = action.payload;
    },
  }
});

export const { setActiveList, setUserManagementType, setUserCode, setUserName } = activeListSlice.actions;
export default activeListSlice.reducer;
